import { ReviewStatus } from 'packages/store/review/types';
import { gatewayClient, createService } from './connectors/httpClient';

export type RequestApprovalData = {
    comment: string | null;
    status: ReviewStatus;
};

const httpClient = gatewayClient('/creatives');

const reviewRequestService = createService(httpClient, (client) => ({
    requestApproval(entityId: number, data: RequestApprovalData) {
        const { status, comment } = data;

        return client.post<{ approvalStatus: ReviewStatus }>(`/${entityId}/approvals/status`, {
            status,
            comment,
        });
    },
}));

export default reviewRequestService;
